<template>
  <model-form
    :model="card"
    modal-type="modal"
  >
    <div class="row q-col-gutter-sm">
      <q-input
        v-model="card.uid"
        class="col-12 sensitive-data"
        label="Barcode"
        :readonly="card.isRemote && !card.isBlank"
        :rules="[val => !$_.isEmpty(val) || 'Field is required']"
        bottom-slots
      />
      <q-input
        v-if="!$_.isNil(card.user)"
        :value="card.user.name"
        class="col-12 sensitive-data"
        label="User"
        readonly
      />
      <q-input
        v-if="!$_.isNil(card.giftCard)"
        :value="card.giftCard.uid"
        class="col-12 sensitive-data"
        label="Gift Card"
        readonly
      />
      <q-input
        v-if="!$_.isNil(card.voucher)"
        :value="card.voucher.uid"
        class="col-12 sensitive-data"
        label="Voucher"
        :readonly="$_.isNil(card.voucherTypeId)"
        :clearable="!$_.isNil(card.voucherTypeId)"
        @clear="card.voucher = null"
      />
      <q-input
        v-if="!$_.isNil(card.issuedVoucherPackage)"
        :value="card.issuedVoucherPackage.uid"
        class="col-12 sensitive-data"
        label="Issued Voucher Package"
        readonly
      />
      <q-select
        v-if="card.isBlank || !$_.isNil(card.voucherTypeId)"
        v-model="card.voucherTypeId"
        class="col-12"
        label="Voucher Type"
        :display-value="$_.isEmpty(voucherTypeOptions) ? 'No Consecutive Voucher Types Found' : undefined"
        :options="voucherTypeOptions"
        option-label="name"
        option-value="id"
        map-options
        emit-value
        :disable="$_.isEmpty(voucherTypeOptions)"
        :readonly="card.isRemote && !card.isBlank"
        :rules="[val => !$_.isNil(val) || 'Field is required']"
        bottom-slots
      />
    </div>
  </model-form>
</template>

<script>
import { VOUCHER_PACKAGE_CARD_TYPES } from 'src/models/voucher/VoucherPackage'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'CardForm',
  components: {
    ModelForm
  },
  configuration: ['voucherPackages', 'voucherTypes'],
  models: {
    card: {
      giftCard: {
        fields: ['id', 'uid']
      },
      user: {
        fields: ['id', 'firstName', 'lastName']
      },
      voucher: {
        fields: ['id', 'uid']
      },
      issuedVoucherPackage: {
        fields: ['id', 'uid']
      },
      voucherType: {
        fields: ['id', 'name']
      }
    }
  },
  computed: {
    voucherTypeOptions () {
      const consecutiveVoucherTypeIds = _(this.voucherPackages.data).map(voucherPackage => {
        return _.filter(_.keys(voucherPackage.voucherTypeOptions), voucherTypeId => {
          return voucherPackage.voucherTypeOptions[voucherTypeId].card_type === VOUCHER_PACKAGE_CARD_TYPES.CONSECUTIVE
        })
      }).flatten().compact().uniq().value()

      return _.filter(this.voucherTypes.data, voucherType => _.includes(consecutiveVoucherTypeIds, voucherType.id.toString()))
    }
  }
}

</script>
